// A még nem mentett regisztráció (jegyek, kiegészítő adatok) vázlata a böngésző sessionStorage-ában,
// rendezvényenként. Az F5-öt és a Vissza → újra "Regisztrálok" útvonalat túléli; a lap bezárásakor vagy
// kilépéskor törlődik. Férőhelyet nem foglal: azt a szerver csak a mentéskor ellenőrzi.
const ELOTAG = 'vazlat_';

export function vazlatOlvasas(rendezvenyID, felhasznaloID) {
    try {
        const szoveg = window.sessionStorage.getItem(ELOTAG + rendezvenyID);
        if (!szoveg) {
            return null;
        }
        const vazlat = JSON.parse(szoveg);
        // más felhasználó vázlatát nem használjuk
        if (!vazlat || vazlat.felhasznaloID !== felhasznaloID || !Array.isArray(vazlat.jegyek)) {
            return null;
        }
        return vazlat;
    } catch (e) {
        return null;
    }
}

export function vazlatIras(rendezvenyID, felhasznaloID, jegyek, adatok) {
    try {
        if (jegyek.length === 0 && !adatok.some(function (a) { return a !== ''; })) {
            window.sessionStorage.removeItem(ELOTAG + rendezvenyID);
            return;
        }
        window.sessionStorage.setItem(ELOTAG + rendezvenyID, JSON.stringify({
            felhasznaloID: felhasznaloID,
            jegyek: jegyek,
            adatok: adatok
        }));
    } catch (e) {
        // tiltott tárhely esetén a vázlat nem marad meg, a működést ez nem érinti
    }
}

export function vazlatTorles(rendezvenyID) {
    try {
        window.sessionStorage.removeItem(ELOTAG + rendezvenyID);
    } catch (e) { }
}

export function osszesVazlatTorlese() {
    try {
        Object.keys(window.sessionStorage).forEach(function (kulcs) {
            if (kulcs.indexOf(ELOTAG) === 0) {
                window.sessionStorage.removeItem(kulcs);
            }
        });
    } catch (e) { }
}

// Hová kell vinni a belépett felhasználót, ha a rendezvényre regisztrálni akar: ha már van megrendelése
// erre a rendezvényre (fizetett vagy nem), annak az oldalára; különben a jegyválasztóba.
export function regisztracioCel(felhasznalo, rendezvenyID) {
    const meglevo = felhasznalo.megrendeltRendezvenyekByID[rendezvenyID];
    if (meglevo !== undefined) {
        return '/megrendeles/' + meglevo.megrendelesID;
    }
    return '/rendezveny/' + rendezvenyID + '/regisztracio';
}
